import styled from 'styled-components';
import { Divider, Icon } from 'antd';


export const PopoverWrapper = styled.div`
  width: 350px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ShowFeedbacksBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px 0;
`;

export const ShowFeedbacksBtn = styled.button`
  font-size: 14px;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.fontSilverPrimary};
  line-height: 17px;
  outline: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
`;

export const Arrow = styled(Icon)`
  padding-left: 5px;
  color: ${({ theme }) => theme.colors.fontSilverPrimary};
`;

export const Title = styled.div`
  font-weight: 500;
`;

export const FeedbacksListWrapper = styled.div`
  max-height: 200px;
  overflow-y: auto;
  padding-right: 15px;
`;

export const ParticipantsListWrapper = styled.div`
  padding-top: 15px;
`;

export const DividerS = styled(Divider)`
  margin: 15px 0;
`;



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/feedbacks/styles.js